"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Currencies = [
    { symbol: 'AUD$', code: 'AUD', name: 'Australian Dollar' },
    { symbol: 'BHD', code: 'BHD', name: 'Bahraini dinar' },
    { symbol: 'R$', code: 'BRL', name: 'Brazilian Real' },
    { symbol: '£', code: 'GBP', name: 'British Pound Sterling' },
    { symbol: 'BND', code: 'BND', name: 'Brunei dollar' },
    { symbol: 'CAD$', code: 'CAD', name: 'Canadian Dollar' },
    { symbol: 'Ұ', code: 'CNY', name: 'Chinese Yuan' },
    { symbol: 'kr', code: 'DKK', name: 'Danish Krone' },
    { symbol: 'E£', code: 'EGP', name: 'Egypt Poimd' },
    { symbol: '€', code: 'EUR', name: 'Euro' },
    { symbol: '₹', code: 'INR', name: 'Indian Rupee' },
    { symbol: '₪', code: 'ILS', name: 'Israeli New Sheqel' },
    { symbol: '¥', code: 'JPY', name: 'Japanese Yen' },
    { symbol: 'JOD', code: 'JOD', name: 'Jordanian dinar' },
    { symbol: 'KWD', code: 'KWD', name: 'Kuwaiti dinar' },
    { symbol: '₦', code: 'NGN', name: 'Nigerian Naira' },
    { symbol: 'kr', code: 'NOK', name: 'Norwegian Krone' },
    { symbol: 'OMR', code: 'OMR', name: 'Omani rial' },
    { symbol: 'QAR', code: 'QAR', name: 'Qatari riyal' },
    { symbol: '₽', code: 'RUB', name: 'Russian Ruble' },
    { symbol: 'SAR', code: 'SAR', name: 'Saudi Arabian riyal' },
    { symbol: 'R', code: 'ZAR', name: 'South Africa Rand' },
    { symbol: '￦', code: 'KRW', name: 'South Korean Won' },
    { symbol: 'SEK', code: 'SEK', name: 'Swedish Krona' },
    { symbol: 'CHF', code: 'CHF', name: 'Swiss Franc' },
    { symbol: '₺', code: 'TRY', name: 'Turkish Lira' },
    { symbol: 'AED', code: 'AED', name: 'UAE dirham' },
    { symbol: '$', code: 'USD', name: 'US Dollar' },
];
//# sourceMappingURL=currencies.js.map